import { atom } from 'jotai';

type User = {
  id: string;
  name: string;
  picture: string;
};

const isAuthResolvedState = atom<boolean>(false);
export const userState = atom<User | null>(null);

export type AuthSate = {
  isAuthResolved: (typeof isAuthResolvedState)['init'];
  user: (typeof userState)['init'];
};

export const authState = atom((get) => {
  return {
    isAuthResolved: get(isAuthResolvedState),
    user: get(userState),
  };
});

export const onAuthResolvedAction = atom(
  null,
  (_, set, after: AuthSate['user']) => {
    set(isAuthResolvedState, true);
    set(userState, after);
  },
);
